/**
 * @flow
 * @relayHash f1de946c9ab5689433731a5ac41d2d8c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type confirmationEmailMutationInput = {|
  emailInput?: ?emailInputType,
  clientMutationId?: ?string,
|};
export type emailInputType = {|
  event_id: string,
  guest_id: string,
  game_id?: ?string,
  game_type_id?: ?string,
  chapter_id?: ?number,
|};
export type confirmationEmailMutationVariables = {|
  input: confirmationEmailMutationInput
|};
export type confirmationEmailMutationResponse = {|
  +sendConfirmationEmail: ?{|
    +code: ?number,
    +message: ?string,
  |}
|};
export type confirmationEmailMutation = {|
  variables: confirmationEmailMutationVariables,
  response: confirmationEmailMutationResponse,
|};
*/


/*
mutation confirmationEmailMutation(
  $input: confirmationEmailMutationInput!
) {
  sendConfirmationEmail(input: $input) {
    code
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "confirmationEmailMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sendConfirmationEmail",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "confirmationEmailMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "confirmationEmailMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "confirmationEmailMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "confirmationEmailMutation",
    "id": null,
    "text": "mutation confirmationEmailMutation(\n  $input: confirmationEmailMutationInput!\n) {\n  sendConfirmationEmail(input: $input) {\n    code\n    message\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a3099a81e323f85828fabd202ad1e155';
module.exports = node;
